import React, { useState } from "react";
import styles from "./UpcomingEvents.module.css"

import { useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { Col, Row } from "react-bootstrap";
import { Carousel } from 'react-responsive-carousel';
import PartialEventCard from "../../components/partialEventCard/PartialEventCard";
import moment from "moment";

export interface IUpcomingEvents {
    eventId: number,
    eventCode: string,
    eventName: string,
    coverImage: string,
    startDate: Date,
    endDate: Date,
}

interface PropsType {
    events: IUpcomingEvents[]
}

const dateFn = (date: Date) => {
    return moment(date).format('Do MMMM');
}

export default function UpcomingEvents(props: PropsType) {

    const responsive = useSelector((state: RootState) => state.responsive);

    // carousel slide states
    const [slide1, setSlide1] = useState(0);
    const [slide2, setSlide2] = useState(1);

    function onRightArrowClick() {
        setSlide1(props.events[slide1 + 1] ? slide1 + 1 : 0);
        setSlide2(props.events[slide2 + 1] ? slide2 + 1 : 0);
    }

    function onLeftArrowClick() {
        let firstSlide = props.events[slide1 - 1] ? slide1 - 1 : props.events.length - 1;
        let secondSlide = props.events[slide2 - 1] ? slide2 - 1 : props.events.length - 1;
        setSlide1(props.events[firstSlide] ? firstSlide : 0);
        setSlide2(props.events[secondSlide] ? secondSlide : 0);
    }

    function onClickImg(slide: IUpcomingEvents) {
        window.location.href = "eventDetail?ec=" + slide.eventCode
    }

    return (<React.Fragment>
        {responsive.isMobileSmallScreen || responsive.isMobileLargeScreen || responsive.isTabScreen ?
            <Row className="home-section-container" style={{ paddingBottom: "2rem" }}>
                <Col md="12" className="home-section-main-heading" style={{ fontSize: "3.5rem" }}>News & Events</Col>
                <Col md="12" hidden>
                    Deals that you cannot miss all throughout the year! Discounts, Surprises and Free gifts for your purchases. Shop with us and enjoy special deals and great savings.
                </Col>
                <Col md="12">
                    <Carousel
                        autoPlay={true}
                        showArrows={false}
                        swipeable={true}
                        showStatus={false}
                        infiniteLoop={true}
                        showIndicators={true}
                        showThumbs={false}
                    >
                        {props.events.map((item, index) => {
                            return (
                                <div key={index} className="d-flex justify-content-center">
                                    <div onClick={() => onClickImg(item)}>
                                        {/* <img src={item.coverImage} alt={item.eventName + `-img`} className="img-fluid" /> */}
                                        <div className={`${styles.mainContainer}`} >
                                            <div className={`${styles.textContainer}`} >
                                                <div className={`${styles.mainText_Mobile}`} >{item.eventName}</div>
                                                <div className={`${styles.date_Mobile}`} >
                                                    <span>{dateFn(item.startDate)}</span>
                                                    {new Date(item.endDate).getTime() == new Date("0001-01-01T00:00:00").getTime() ?
                                                        null :
                                                        <span> - {dateFn(item.endDate)}</span>

                                                    }
                                                </div>
                                                <div className={`${styles.readMore}`} >Read More -</div>
                                            </div>
                                            <img src={item.coverImage} alt={`secondUpcomingEvents-img`}                             
                                            className={`${styles.image} img-fluid`}></img>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Carousel>
                    <Col md="12" className={`${styles.controlsContainer}`} >
                        <a href="/eventListing" style={{ margin: "auto", fontSize: "1.4rem", cursor: "pointer", color: "black", textDecoration: "none" }} >View All</a>
                    </Col>

                </Col>
            </Row>
            :
            <Row className={` ${styles.eventsContainer} home-section-container`} >
                <Col md="12">
                    <Col md="12" className="home-section-main-heading" style={{ fontSize: "3.5rem", paddingTop: "1px" }}>News & Events</Col>
                    <Col md="12" style={{ paddingBottom: "18px" }} hidden>
                        Deals that you cannot miss all throughout the year! Discounts, Surprises and Free gifts for your purchases. Shop with us and enjoy special deals and great savings.
                    </Col>

                    <Col md="12">
                        <div className="d-flex overflow-hidden">
                            <div className={`${styles.mainContainer}`} onClick={() => onClickImg(props.events[slide1])}>
                                <div className={`${styles.textContainer}`} >
                                    <div className={`${styles.mainText}`} >{props.events[slide1].eventName}</div>
                                    <div className={`${styles.date}`} >
                                        <span>{dateFn(props.events[slide1].startDate)}</span>
                                        {new Date(props.events[slide1].endDate).getTime() == new Date("0001-01-01T00:00:00").getTime() ?
                                            null :
                                            <span> - {dateFn(props.events[slide1].endDate)}</span>

                                        }
                                    </div>
                                    <div className={`${styles.readMore}`} >Read More -</div>
                                </div>
                                <img src={props.events[slide1].coverImage} alt={`secondUpcomingEvents-img`}                             
                                className={`${styles.image} img-fluid d-flex overflow-hidden`}></img>
                            </div>

                            <div className={`${styles.mainContainer}`}  onClick={() => onClickImg(props.events[slide2])}>
                                <div className={`${styles.textContainer}`} >
                                    <div className={`${styles.mainText}`} >{props.events[slide2].eventName}</div>
                                    <div className={`${styles.date}`} >
                                        <span>{dateFn(props.events[slide2].startDate)}</span>
                                        {new Date(props.events[slide2].endDate).getTime() == new Date("0001-01-01T00:00:00").getTime() ?
                                            null :
                                            <span> - {dateFn(props.events[slide2].endDate)}</span>

                                        }
                                    </div>
                                    <div className={`${styles.readMore}`} >Read More -</div>
                                </div>
                                <img src={props.events[slide2].coverImage} alt={`secondUpcomingEvents-img`} 
                                className={`${styles.image} img-fluid d-flex overflow-hidden`}></img>
                            </div>

                            {/* <img src={props.events[slide1].coverImage} alt={`secondUpcomingEvents-img`} 
                            onClick={() => onClickImg(props.events[slide1])} 
                            style={{ marginRight: "2rem", minWidth: "70%", height: "70%", cursor: "pointer" }} 
                            className={`${styles.subImage} img-fluid`}></img>

                            <img src={props.events[slide2].coverImage} alt={`thirdUpcomingEvents-img`} 
                            onClick={() => onClickImg(props.events[slide2])} 
                            style={{ minWidth: "70%", height: "70%", cursor: "pointer" }} 
                            className={`${styles.subImage} img-fluid`}></img> */}

                        </div>
                    </Col>
                    <Col md="12" className={`${styles.controlsContainer}`} >
                        <i style={{ marginRight: "1rem", cursor: "pointer" }} className="fas fa-long-arrow-alt-left" onClick={() => onLeftArrowClick()}></i>
                        <a href="/eventListing" style={{ margin: "auto", fontSize: "1.4rem", cursor: "pointer", color: "black", textDecoration: "none" }} >View All</a>
                        <i style={{ position: "absolute", right: "0", cursor: "pointer" }} className="fas fa-long-arrow-alt-right" onClick={() => onRightArrowClick()}></i>
                    </Col>
                </Col>
            </Row>
        }

    </React.Fragment>)
}